module.exports = __webpack_public_path__ + "static/media/aboutUs.c0198fd1.png";